<!--
* UIID: UI-DLB-FF-100
* UI Name: FlatFile Layout
* Modify Date: 2020/05/11
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.flatFileLayout.page_header')
        }}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <!-- 2021.07.27 163189 SPKA-168 change layout like TRANSACTION LOG -->
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="6"
            md="6"
          >
            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].FILE_NAME"
                  :label="$t('lbl.common.conditionSearch.findbyLayoutName')"
                  @keyup.enter="queryList"
                  class="custom-selectbox"
                  height="40"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5" class="pt-0 pb-0">
                <v-autocomplete
                  ref="bussinessSearch"
                  v-model="searchBusiness"
                  :label="$t('lbl.common.conditionSearch.selectBusinessName')"
                  :items="this.bizItem"
                  @change="this.queryList"
                  :menu-props="{ offsetY: true }"
                  class="custom-selectbox"
                  height="40"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0 pr-24px">
                <v-select
                  v-model="searchType"
                  :label="$t('lbl.common.conditionSearch.selectType')"
                  :items="this.codeItem"
                  @change="this.queryList"
                  class="custom-selectbox"
                  height="40"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1"
            cols="12"
            lg="6"
            md="6"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-autocomplete
                v-model="masterSearchItems.init.DAT_TYPE"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :items="dateTypes"
                :menu-props="{ offsetY: true }"
                @change="changeDtTp"
                class="custom-selectbox"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.FR_DAT"
                  :max="getMaxDate"
                  @input="
                    fromdate_menu = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn @click="fromdate_menu = false" text color="primary">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)"
                    text
                    color="primary"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :allowed-dates="allowedDates"
                  v-model="masterSearchItems.init.TO_DAT"
                  @input="
                    todate_menu = false;
                    changeDate('to');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn @click="todate_menu = false" text color="primary">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)"
                    text
                    color="primary"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                @click.native="queryList"
                class="btn-width-1 btn btn-top btn-search"
                color="primary"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- // 2021.11.24 203728 SPKA-274 modify paging -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  :disabled="!$auth.manage"
                  class="btn btn-add"
                  @click="openAddFlatFileDialog"
                  color="#353f61"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
                <v-tooltip
                  top
                  :disabled="!isEnableDelete || !$auth.manage"
                  :max-width="tooltipWidth"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip">
                      <v-btn
                        @click="deleteFlatFile"
                        :disabled="isEnableDelete || !$auth.manage"
                        class="btn btn-delete"
                        color="#cd5f5f"
                      >
                        {{ $t('btn.common.delete') }}
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ $t('msg.customerDataAnalysis.deleteTooltipMsg') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="1" md="1"></v-col>
          <v-col lg="5" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0 d-flex" md="6">
                <v-btn
                  @click="downOriginMulti"
                  :disabled="isEnableDelete"
                  x-small
                  class="btn-height-custom btn-excel mb-0 mt-3"
                >
                  {{ $t('btn.monitoring.originFiles') }}
                </v-btn>
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  :items="searchByItems"
                  @change="onFilterFlatFile"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="6">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onFilterFlatFile"
                  @click:append="onFilterFlatFile"
                  v-on:keyup.enter="onFilterFlatFile"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  hide-details
                  dense
                  solo
                  heigth="30"
                  append-icon="fa fa-search"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- First Grid table page -->
    <v-row>
      <!-- // 2021.5.19 203728 Issue 53 No display spinner -->
      <!-- 2021.12.8 203728 SPKA-305 show bottom border -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <!-- // 2021.11.24 203728 SPKA-274 modify paging -->
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="SummaryList.headers"
          :items="this.mainGrid"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          :class="[
            'list-table flat-file-table srm-list-table custom-border-table',
            mainGrid.length > 0 ? '' : 'custom-border-table-not-data',
          ]"
          item-key="ROWID"
          sort-by="FFL_UPD_DT"
          :sort-desc="true"
          pb-2
        >
          <template v-slot:header.checkbox="{}">
            <v-checkbox
              @change="selectAllChange"
              class="select-checkbox-layout-table align-center justify-center flat-file-checkbox"
              color="#dbd7db"
              dense
              hide-details
            ></v-checkbox>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.ROWID"
                @click="onClickRow(item)"
                :class="[selectedRow === item.ROWID ? 'selected_row' : '']"
              >
                <td class="checkbox-col">
                  <v-checkbox
                    v-model="item.checked"
                    @click.native="selectItemChange($event, item)"
                    @click.native.stop
                    id="item.checked"
                    class="select-checkbox-layout-table align-center justify-center flat-file-checkbox"
                    color="#dbd7db"
                    dense
                    hide-details
                  ></v-checkbox>
                </td>
                <td class="locked-col">
                  <v-icon
                    v-if="item.FFL_CHKIN_YN === 'Y' && !$auth.manage"
                    small
                    @click.native="releaseLockedMap(item)"
                    color="checkbox-col-lock darken-1"
                    >fas fa-check-square</v-icon
                  >
                  <v-icon
                    v-if="item.FFL_CHKIN_YN === 'N'"
                    small
                    color="checkbox-col-unlock darken-1"
                    >far fa-window-close</v-icon
                  >
                </td>
                <td class="layout-name-col">
                  <div v-if="!$auth.manage">{{ item.FFL_FILE_NAME }}</div>
                  <a v-else class="link-file-text" @click="openModifyFlatFileDialog(item)">{{
                    item.FFL_FILE_NAME
                  }}</a>
                </td>
                <td class="csv-file-col">
                  <a class="link-file-text" @click="downloadFlatFile(item)">{{
                    item.FFL_CSV_FILE_NAME
                  }}</a>
                </td>
                <td class="business-name-col">{{ item.SVC_ID_NM }}</td>
                <td class="type-col text-center">{{ item.FFL_FRMT_TP_NM }}</td>
                <td class="version-col">
                  <div v-if="!$auth.manage">{{ item.FFL_VERSION }}</div>
                  <a v-else class="link-file-text" @click="openFlatFileLayoutVersion(item)">{{
                    item.FFL_VERSION
                  }}</a>
                </td>
                <td class="type-col text-center">
                  <div v-if="!$auth.manage">{{ item.APPLIED_MAP_CNT }}</div>
                  <a v-else class="link-file-text" @click.stop="showSRMList(item, $event)">{{
                    item.APPLIED_MAP_CNT
                  }}</a>
                </td>
                <td class="date-col no-wrap text-center">{{ item.FFL_UPD_DT }}</td>
                <td class="update-user-col">{{ item.FFL_UPD_USR }}</td>
                <!-- CLV 2020/20/08 implement "Applied Map" -->
                <v-overlay
                  :absolute="absolute"
                  :value="overlay"
                  :dark="$vuetify.theme.dark"
                  class="tableOverlay"
                >
                  <v-data-table
                    :headers="overlayTableHeader"
                    :items="flatMapData"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    :hide-default-header="true"
                    class="overlay-table"
                  >
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr @click.stop="closeTbOverlay">
                          <th class="center">{{ headers[0].text }}</th>
                          <th class="hidden">{{ headers[1].text }}</th>
                          <th class="hidden">{{ headers[2].text }}</th>
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id" @click.stop="closeTbOverlay">
                          <td>{{ item.MAP_NAME }}</td>
                          <td class="hidden">{{ item.MAP_MSG_VER }}</td>
                          <td class="hidden">{{ item.MAP_MSG_ID }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-overlay>
              </tr>
            </tbody>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- // 2021.11.24 203728 SPKA-274 modify paging  -->
    <v-row v-show="mainGrid.length > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    :items="itemShow"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{
                      mainGrid.length - itemsPerPage * page > 0
                        ? itemsPerPage * page
                        : mainGrid.length
                    }}
                    of {{ mainGrid.length }}
                  </v-label>
                </div>
                <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button
                  type="button"
                  @click="page = 1"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="page = pageCount"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <flatFile-layout-version-dialog
        v-if="dialog.type == 'flatFileLayoutVersion'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="queryList"
        :dialogCheckIn="openFlatFileLayoutCheckIn"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></flatFile-layout-version-dialog>

      <flatFile-layout-check-in-dialog
        v-if="dialog.type == 'flatFileLayoutCheckIn'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="queryList"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></flatFile-layout-check-in-dialog>

      <addFlatFileLayout
        v-if="dialog.type == 'addFlatFileLayout'"
        ref="addReferenceFile"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @search="queryList"
        class="form-popup"
        @validate-popup="validatePopup"
        @blocked-item="blockedItem"
      ></addFlatFileLayout>
    </div>
    <dialogWindow
      ref="SearchCondition"
      :detail="$t('msg.common.fromDateValidate')"
      size="max"
      title="Search"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the selected items'])"
      @select-ok="onDeleteFlatFile"
      size="max"
      title="Delete FlatFile Layout"
      color="confirmation"
      show-cancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="warningDialog"
      :title="$t('msg.common.warning.title')"
      size="max"
      :detail="$t('msg.common.noSelectItem')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="deleteSuccesssDialog"
      :detail="$t('msg.flatFileLayout.deleteSuccess')"
      @select-ok="queryList"
      size="max"
      title="Delete Success"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="validatePopup"
      size="max"
      detail="Same file name already exists. Please rename and try again."
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import flatFileLayoutVersionDialog from '@/vue-dlb/views/flatfile/FlatFileLayoutVersionHistory.vue';
import flatFileLayoutCheckInDialog from '@/vue-dlb/views/flatfile/FlatFileLayoutCheckIn.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

import AddFlatFileLayout from '@/vue-dlb/views/flatfile/AddFlatFileLayout.vue';
import { DownloadFile } from '@/vue-dlb/models/DownloadFile';

import { resizeTableHeight } from '@/vue-dlb/common/common';
import cfg from '@/vue-caas/config/config.js';

// 2021.5.19 203728 Issue 53
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';

export default {
  components: {
    flatFileLayoutVersionDialog,
    flatFileLayoutCheckInDialog,
    AddFlatFileLayout,
    dialogWindow,
    // 2021.5.19 203728 Issue 53
    SystemProgress,
  },
  watch: {
    searchBusiness() {
      if (typeof this.searchBusiness == 'undefined') {
        this.searchBusiness = '';
        this.$refs.bussinessSearch.blur();
      }
    },
    // 2021.11.24 203728 SPKA-274 modify paging
    page() {
      this.pageEnter = this.page;
    },
  },
  computed: {
    // 2021.5.19 203728 Issue 53
    ...mapState('common', {
      bizCodeList: 'bizCodeList',
      codeList: 'codeList',
      repomenuMode: 'repomenuMode',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('fflayout', {
      mainGrid: 'mainGrid',
      appliedList: 'appliedList',
    }),
    // 203728 SPKA-49 issue 5 apply date conndition
    getMaxDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return getAppliedTimeZone();
      } else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return this.masterSearchItems.init.FR_DAT;
      } else {
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    isEnableDelete() {
      if (this.selectMasterRows.length > 0) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      ACCESS_REPO_YN: '', // common mandatory for ADMIN_YN
      fromdate_menu: false,
      todate_menu: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      pageEnter: 1, // 2021.11.24 203728 SPKA-274 modify paging
      search: '',
      flatFileVersionHistoryItem: null,
      tooltipWidth: 300,
      dateTimeFormat: '',
      isCreated: false,
      tableHeight: '',
      itemShow: [
        { text: 'Show 10', value: 10 },
        { text: 'Show 25', value: 25 },
        { text: 'Show 50', value: 50 },
        { text: 'Show 75', value: 75 },
        { text: 'Show 100', value: 100 },
      ],
      SummaryList: {
        headers: [
          { text: '', value: 'checkbox', width: '20px' },
          { text: 'Locked', value: 'FFL_CHKIN_YN', width: '70px' },
          { text: 'Layout Name', value: 'FFL_FILE_NAME', 'min-width': '250px' },
          { text: 'CSV File', value: 'FFL_CSV_FILE_NAME', width: '300px' },
          { text: 'Business Name', value: 'SVC_ID_NM', width: '300px' },
          { text: 'Type', value: 'FFL_FRMT_TP_NM', width: '100px' },
          { text: 'Version', value: 'FFL_VERSION', width: '60px' },
          { text: 'Applied Map', value: 'APPLIED_MAP_CNT', width: '200px' },
          { text: 'Update Date', value: 'FFL_UPD_DT', width: '170px', sortable: true },
          { text: 'Update User', value: 'FFL_UPD_USR', width: '200px' },
        ],
        selected: [],
        data: [],
      },
      bizCodeSearchItems: {
        header: ['SVC_DIR'],
        data: [
          {
            SVC_DIR: '',
          },
        ],
      },
      codeSearchItems: {
        header: ['GRP_CODE'],
        data: [
          {
            GRP_CODE: '',
          },
        ],
      },
      flatfileDownloadItems: {
        header: ['FILE_ID', 'SAVE_NAME'],
        data: [
          {
            FILE_ID: '',
            SAVE_NAME: '',
          },
        ],
      },
      releaseLockItems: {
        header: ['FFL_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            FFL_PRCS_NO: '',
            LOCK_YN: '',
          },
        ],
      },
      masterSearchItems: {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'FILE_NAME',
          'SVC_ID',
          'FRMT_TP',
          'FR_DAT',
          'TO_DAT',
          'DAT_TYPE',
        ],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            OWNR_CUST_ID: `${$cookies.get('ownr-id')}`,
            FILE_NAME: '',
            SVC_ID: '',
            FRMT_TP: '',
            FR_DAT: '',
            TO_DAT: '',
            DAT_TYPE: '',
          },
        ],
        init: {
          // 203728 SPKA-49 issue 5 apply date conndition
          FR_DAT: beforeOneMonth(),
          TO_DAT: getAppliedTimeZone(),
          FR_DAT_PREV: beforeOneMonth(),
          TO_DAT_PREV: getAppliedTimeZone(),
          FR_DAT_ERROR: [],
          TO_DAT_ERROR: [],
          DAT_TYPE: '',
        },
      },
      deleteDataParams: {
        header: ['FFL_PRCS_NO'],
        data: [],
      },
      bizItem: [{ text: 'All', value: 'all' }],
      codeItem: [{ text: 'All', value: 'all' }],
      customerItem: [{ text: 'All', value: 'allCust' }],
      selectMasterRows: [],
      searchBy: 'all',
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Layout', value: 'FFL_FILE_NAME' },
        { text: 'CSV File', value: 'FFL_CSV_FILE_NAME' },
        { text: 'Business Name', value: 'SVC_ID_NM' },
        { text: 'Type', value: 'FFL_FRMT_TP_NM' },
        { text: 'Version', value: 'FFL_VERSION' },
        { text: 'UpDate Date', value: 'FFL_UPD_DT' },
        { text: 'Upload User', value: 'FFL_UPD_USR' },
      ],
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      searchBusiness: '',
      searchType: '',
      searchName: '',
      selected: null,
      dialogWidth: 400,
      flatFileData: [],
      // CLV 2020/20/08 implement "Applied Map"
      overlayTableHeader: [
        { text: 'Applied Map Name', value: 'MAP_NAME' },
        { text: 'EDI Version', value: 'MAP_MSG_VER' },
        { text: 'Message ID', value: 'MAP_MSG_ID' },
      ],
      overlay: false,
      absolute: false,
      flatMapData: [],
      dateTypes: [
        { value: '', text: 'Search by' },
        { value: 'UPDT', text: 'Update Date' },
      ],
      // 2021.5.19 203728 Issue 53
      isLoading: false,
      selectedRow: '',
      lockItems: {
        header: ['FFL_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            FFL_PRCS_NO: '',
            LOCK_YN: '',
          },
        ],
      },
    };
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    async downOriginMulti() {
      await Promise.all(
        this.selectMasterRows.map(async (e) => {
          let downloadfile = new DownloadFile();
          downloadfile.data[0].FILE_ID = e.FILE_ID;
          downloadfile.data[0].SAVE_NAME = e.FFL_FILE_NAME;

          Store.dispatch('common/DownloadFileFromServer', downloadfile);
        }),
      );

      if (data.length > 1) {
        this.zipFiles(data);
      } else if (data.length == 1) {
        this.downloadFileView(data[0].result, data[0].title);
      }
    },
    async blockedItem(item) {
      await this.queryList(item);
      await setTimeout(() => {
        this.$nextTick(() => {
          this.queryList();
          this.isLoading = false;
        });
      }, 1000);
    },
    validatePopup() {
      this.$refs.validatePopup.dialog = true;
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString =
        side === 'from' ? this.masterSearchItems.init.FR_DAT : this.masterSearchItems.init.TO_DAT;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from'
          ? (this.masterSearchItems.init.FR_DAT = dateString)
          : (this.masterSearchItems.init.TO_DAT = dateString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT;
        }
      }
    },
    onClickRow(item) {
      this.selectedRow = item.ROWID;
    },
    // 2021.11.24 203728 SPKA-274 process change page by input textbox
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    // 203728 SPKA-49 issue 5 apply date conndition
    changeDtTp() {
      if (
        this.masterSearchItems.init.DAT_TYPE == undefined ||
        this.masterSearchItems.init.DAT_TYPE == null ||
        this.masterSearchItems.init.DAT_TYPE == ''
      ) {
        this.masterSearchItems.init.FR_DAT = '';
        this.masterSearchItems.init.TO_DAT = '';
      } else {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT || beforeOneMonth();
        this.masterSearchItems.init.TO_DAT =
          this.masterSearchItems.init.TO_DAT || getAppliedTimeZone();
      }
    },
    getBizCode() {
      this.bizCodeSearchItems.data[0].SVC_DIR = '';
      Store.dispatch('common/getBizCode', this.bizCodeSearchItems).then(() => {
        console.log('--------- Finished to process biz ----------');
        for (let i = 0; i < this.bizCodeList.length; i++) {
          let bizObj = {};
          bizObj.text = this.bizCodeList[i].SVC_NAME;
          bizObj.value = this.bizCodeList[i].SVC_ID;
          this.bizItem.push(bizObj);
        }
      });
    },

    getCode() {
      this.codeSearchItems.data[0].GRP_CODE = 'B02';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        console.log('--------- Finished to process code List ----------');
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.codeItem.push(codeObj);
        }
      });
    },
    async queryList(item) {
      // 203728 SPKA-49 issue 5 apply date conndition
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        // 2021.5.19 203728 Issue 53
        if (!this.isLoading) this.isLoading = true;
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.FR_DAT,
        );
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.TO_DAT,
        );
        this.masterSearchItems.data[0].ADMIN_YN = this.ACCESS_REPO_YN; // this.$cookies.get('user-admin-yn');
        this.masterSearchItems.data[0].SVC_ID = this.searchBusiness;
        this.masterSearchItems.data[0].CUST_ID = this.$cookies.get('comp-id');
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        if (this.masterSearchItems.data[0].SVC_ID === 'all') {
          this.masterSearchItems.data[0].SVC_ID = '';
        }
        this.masterSearchItems.data[0].FRMT_TP = this.searchType;
        if (this.masterSearchItems.data[0].FRMT_TP === 'all') {
          this.masterSearchItems.data[0].FRMT_TP = '';
        }
        this.flatFileData = [];
        Store.dispatch('fflayout/queryList', this.masterSearchItems)
          .then(() => {
            if (item) {
              let checkNameCustId = this.mainGrid.filter(
                (e) => e.MST_CUST_ID == item.custId && e.FFL_FILE_NAME == item.fileName,
              );
              this.lockItems.data[0].FFL_PRCS_NO = checkNameCustId[0].FFL_PRCS_NO;
              this.lockItems.data[0].LOCK_YN = 'Y';
              Store.dispatch('fflayout/updateLock', this.lockItems);
            } else {
              // 2021.5.19 203728 Issue 53
              this.isLoading = false;
            }
          })
          .catch((ex) => {
            // 2021.5.19 203728 Issue 53
            this.isLoading = false;
          });
      } else {
        this.$refs.SearchCondition.dialog = true;
      }
    },

    onFilterFlatFile(str) {
      Store.commit('fflayout/SET_STORE_FLAT_FILE_FILTER', {
        filter: this.searchBy,
        str: this.search,
      });
    },

    deleteFlatFile() {
      if (this.selectMasterRows.length === 0) {
        this.$refs.warningDialog.dialog = true;
      }
      if (this.selectMasterRows.length > 0) {
        this.$refs.deleteDialog.dialog = true;
      }
    },

    onDeleteFlatFile() {
      if (this.selectMasterRows.length > 0) {
        for (var i = 0; i < this.selectMasterRows.length; i++) {
          this.deleteDataParams.data[i] = {
            FFL_PRCS_NO: `${this.selectMasterRows[i].FFL_PRCS_NO}`,
          };
        }
        Store.dispatch('fflayout/deleteFFLayout', this.deleteDataParams).then(() => {
          this.$refs.deleteSuccesssDialog.dialog = true;
        });
      }
      this.selectMasterRows = [];
    },

    openFlatFileLayoutVersion(itemRow) {
      let type = 'flatFileLayoutVersion';
      let item = {
        ROWID: 0,
      };
      this.flatFileVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('flatFileLayoutVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    openFlatFileLayoutCheckIn(param) {
      let type = 'flatFileLayoutCheckIn';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('flatFileLayoutCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    openModifyFlatFileDialog(rowItem) {
      let type = 'addFlatFileLayout';
      let item = {
        ROWID: 0,
        action: 'modify',
        data: rowItem,
      };
      let indexArrDialog = this.findDialog('addFlatFileLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    openAddFlatFileDialog() {
      let type = 'addFlatFileLayout';
      let item = {
        ROWID: 0,
        action: 'add',
      };
      let indexArrDialog = this.findDialog('addFlatFileLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },

    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },

    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },

    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },

    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },

    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },

    releaseLockedMap(item) {
      this.releaseLockItems.data[0].LOCK_YN = 'N';
      this.releaseLockItems.data[0].FFL_PRCS_NO = item.FFL_PRCS_NO;
      Store.dispatch('fflayout/updateLock', this.releaseLockItems).then(() => {
        this.queryList();
      });
    },

    downloadFlatFile(item) {
      this.flatfileDownloadItems.data[0].FILE_ID = item.FFL_CSV_FILE_ID;
      this.flatfileDownloadItems.data[0].SAVE_NAME = item.FFL_CSV_FILE_NAME;
      Store.dispatch('common/DownloadFileFromServer', this.flatfileDownloadItems).then(() => {
        console.log('--------- Finished to process ----------');
      });
    },

    selectAllChange(value) {
      let selectAllItems = [];
      if (value) {
        for (let i = 0; i < this.mainGrid.length; i++) {
          let item = this.mainGrid[i];
          item.checked = value;
          selectAllItems.push(item);
        }
        this.selectMasterRows = selectAllItems;
      } else {
        for (let i = 0; i < this.mainGrid.length; i++) {
          let item = this.mainGrid[i];
          item.checked = false;
        }
        this.selectMasterRows = [];
      }
    },

    selectItemChange(event, item) {
      let checked = item.checked;
      if (checked == true) {
        this.selectMasterRows.push(item);
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'ROWID');
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
    },

    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },

    // CLV 2020/20/08 implement "Applied Map"
    showSRMList(exData, e) {
      let left = e.clientX;
      if (this.overlay === true) {
        this.overlay = false;
      } else {
        let listResult = [];
        listResult = this.appliedList.filter((item) => {
          if (item.FFL_PRCS_NO === exData.FFL_PRCS_NO) {
            return true;
          }
          return false;
        });
        this.flatMapData = listResult;
        let top = e.clientY;
        $('.tableOverlay').css('top', top) + 20;
        $('.tableOverlay').css('left', left);
        this.overlay = true;
      }
    },
    closeTbOverlay() {
      this.overlay = false;
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
  },
  created() {
    // By April to Show EDI Asset depending on Authority.
    // Check whether entered from repository menu on top selection of customer or User menu
    if (cfg.isDlbMybatis) {
      if ($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'Y';
      else this.ACCESS_REPO_YN = 'N';
    } else {
      if (this.repomenuMode) {
        // Repository Menu
        // if($cookies.get('comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY'; // CLT Super Provider
        if ($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY';
        // CLT Super Provider
        else this.ACCESS_REPO_YN = 'YN'; // Normal User Admin
      } else {
        // Normal User
        this.ACCESS_REPO_YN = 'NN';
      }
    }
    this.tooltipWidth = cfg.tooltipWidth;
    this.dateTimeFormat = cfg.dateTimeFormat;
    this.queryList();
    this.changeDtTp();
    this.getBizCode();
    this.getCode();
    this.isCreated = true;
  },
  // 2021.11.24 203728 SPKA-274 modify paging
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {
    //CLV 2020/20/08 implement "Applied Map"
    $('body').click((event) => {
      this.closeTbOverlay();
    });
  },
  beforeDestroy() {
    $('body').unbind('click');
  },
};
</script>

<style>
.flat-file-table .locked-col {
  text-align: center;
}
.flat-file-table th:first-child i.v-icon.v-data-table-header__icon {
  display: none;
}
.flat-file-table .layout-name-col {
  color: #0082ba;
}
.flat-file-table .csv-file-col {
  color: #0082ba;
  text-align: left;
}
.theme--light .flat-file-table .business-name-col {
  text-align: left;
  color: #18236d;
  font-weight: bold;
}
.flat-file-table .type-col {
  text-align: left;
}
.flat-file-table .version-col {
  text-align: center;
  color: #0082ba;
  font-weight: bold;
}
.flat-file-table .update-user-col {
  text-align: left;
}
.flat-file-table .customer-col {
  text-align: left;
}
.flat-file-table .selected-row {
  background: #eaf1f8 !important;
}
.flat-file-table thead tr th.text-start {
  color: rgb(255, 255, 255) !important;
  border-right: 1px solid #e0e6f2;
  text-align: center !important;
}
/* .flat-file-table tbody tr:last-child {
  border-bottom: 2px solid #A9BADD;
} */
.mdi:after,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 'Material Design Icons';
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
}
.theme--dark .page-control-content {
  background: #252731;
}
/* CLV 2020/20/08 implement "Applied Map" css */
.tableOverlay {
  /* bottom: 83px;
  right: 15px; */
  top: unset;
  left: unset;
  height: 151px;
  min-width: 150px;
  width: 163px;
}
.tableOverlay .v-overlay__content {
  position: absolute;
  top: 0;
}
.flat-file-overlay-table .srmDialogHeader {
  color: black !important;
  font-size: 10px !important;
  line-height: 14px;
  text-align: center !important;
}
.tableOverlay .v-overlay__scrim {
  opacity: 0 !important;
}
.flat-file-overlay-table {
  background-color: #ffffff !important;
  color: black !important;
  height: auto;
  /* width: 350px; */
  overflow-x: hidden;
}

.theme--dark .flat-file-overlay-table {
  background-color: #191a21 !important;
  color: #bbbbbb !important;
}

.flat-file-overlay-table > div.v-data-table__wrapper > table {
  border-collapse: separate;
}

.theme--light .flat-file-overlay-table > div.v-data-table__wrapper > table thead th {
  border-top: none !important;
}

.flat-file-overlay-table td.sender-col,
.flat-file-overlay-table td.receiver-col,
.flat-file-overlay-table td.message-col {
  font-size: 10px !important;
  line-height: 14px !important;
  border: 1px solid #d0d4dd;
  text-align: center !important;
}
</style>
